import { apiSubmit } from '../main';

export const apiRequestAsync = ({ request_details }) => {
    return new Promise(async (resolve, reject) => {
      let response = null;
  
      try {
        
        response = await apiSubmit(request_details);

        console.log('apiRequestAsync.response', response);
        
        resolve(response);
  
      } catch (error) {
        console.log('apiRequestAsync.error', error);
        response = (error.error && `${error.error.status}: ${error.error.message}`) || error.message || error;
        
        reject(error.error || error.message || error);
      }
    });
  };
  